import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTournamentByFriendlyToken } from '../../api/api';
import TourRegForm from '../TourRegForm/TourRegForm';
import TourCurForm from '../TourCurForm/TourCurForm';
import Spinner from '../Spinner/Spinner';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

const FriendlyTournament = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [tournament, setTournament] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadTournament = async () => {
            setIsLoading(true);
            const result = await fetchTournamentByFriendlyToken(token);
            if (result.success) {
                setTournament(result.data);
            } else {
                setError('Turniej towarzyski nie został znaleziony — sprawdź poprawność linka.');
            }
            setIsLoading(false);
        };
        loadTournament();
    }, [token]);

    if (isLoading) return <Spinner size="large" />;
    if (error) return <ErrorMessage error={error} />;
    if (!tournament) return null;

    const onReturn = () => navigate('/');

    if (tournament.status === 'ACTIVE') {
        return <TourCurForm tournament={tournament} isArchived={false} onReturn={onReturn} />;
    }
    if (tournament.status === 'COMPLETED') {
        return <TourCurForm tournament={tournament} isArchived={true} onReturn={onReturn} />;
    }
    return <TourRegForm tournament={tournament} onReturn={onReturn} />;
};

export default FriendlyTournament;
